<div class="col-sm-12 login-form">
    <div class=" row justify-content-md-center">
      <div class="col-8">
        <img width="100%"src="assets/img/Picto_Global/logoclem.png" alt="clem" />
      </div>
      <h3>{{loadingText}}</h3>
      <mat-progress-bar class="col-12" mode="indeterminate"></mat-progress-bar>
    </div>
  </div>